<div>
  <div class="calc-soild"></div>
  <div class="main-border-div position-relative">
    <header class="header-wrapper">
      <h5 class="head">Products</h5>
      <div class="first-section">
        <div class="search-box">
          <img
            src="../../../../../assets/Icons/Search_Magnifying_Glass.svg"
            class="me-2"
            alt=""
          />
          <input
            type="text"
            name="searchProduct"
            (keyup)="onSearchKeyUp($event)"
            class="search-input-box"
            placeholder="Search..."
          />
        </div>
        <button
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasAddEditProduct"
          aria-controls="offcanvasAddEditProduct"
          class="primary-btn btn ms-1"
          *ngIf="hasPermission('Product:Create')"
          (click)="sendProductIdForAddUpdate(0)"
        >
          Add Product
        </button>
      </div>
    </header>
    <div class="table-container mb-0">
      <table class="table">
        <thead class="main-head sticky-top" style="z-index: 1">
          <tr>
            <th scope="col" style="padding-left: 20px">
              Product
              <img
                class="sort-icon"
                (click)="changeSorting('Name')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th scope="col">
              SKU
              <img
                class="sort-icon"
                (click)="changeSorting('SKU')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th scope="col">
              Location
              <img
                class="sort-icon"
                (click)="changeSorting('WarehouseLocationId')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th scope="col">
              Created Date
              <img
                class="sort-icon"
                (click)="changeSorting('CreatedAt')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th class="text-left" scope="col">
              Status
              <img
                class="sort-icon"
                (click)="changeSorting('Status')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th class="text-left" scope="col">
              Internal Status
              <img
                class="sort-icon"
                (click)="changeSorting('InternalStatus')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th class="text-left" scope="col">
              Listing Status
              <img
                class="sort-icon"
                (click)="changeSorting('InternalStatus')"
                src="/assets/Icons/sort_icon.svg"
                alt="sort"
              />
            </th>
            <th class="text-center" scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedProductsList.items">
            <td class="col" style="padding-left: 20px">
              <div class="pd-name">
                <div class="img-cover">
                  <img
                    [src]="
                      item?.productImages?.[0]?.url ??
                      '../../../../../assets/Icons/ic_demo_img.svg'
                    "
                  />
                </div>
                <a
                  class="ms-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasProductDetails"
                  aria-controls="offcanvasProductDetails"
                  (click)="getProductDetails(item)"
                  >{{ item.name }}</a
                >
              </div>
            </td>
            <td class="col">
              {{ item.sku }}
            </td>
            <td class="col">
              {{ item.warehouseLocation?.name || "-" }}
            </td>
            <td class="col">
              {{ item.createdAt | date: "MM/dd/yyyy hh:mm a" }}
            </td>
            <td class="col text-left">
              <div class="d-flex justify-content-start align-items-center sts">
                <span>
                  {{ item.statusName }}
                </span>
              </div>
            </td>
            <td class="col text-left">
              <div class="d-flex justify-content-start align-items-center sts">
                <img
                  style="height: 30px"
                  [src]="internalStatusIcons[item.internalStatus - 1]"
                />
                <span>
                  {{ item.internalStatusName }}
                </span>
              </div>
            </td>
            <td class="col text-left">
              <div class="d-flex justify-content-start align-items-center sts">
                <img
                  *ngIf="item.listerProduct.listingStatus < 4"
                  [src]="
                    listingStatusIcons[item.listerProduct.listingStatus - 1]
                  "
                />
                <span>
                  {{ item.listerProduct.listingStatusName }}
                </span>
              </div>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-start al">
                <button
                  class="btn border-0 pe-3"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasProductDetails"
                  aria-controls="offcanvasProductDetails"
                  *ngIf="hasPermission('Product:View')"
                  (click)="getProductDetails(item)"
                >
                  <img
                    src="../../../../../assets/Icons/ic_eye.svg"
                    alt="edit"
                    matTooltip="View Details"
                    matTooltipPosition="above"
                    class="view"
                  />
                </button>
                <button
                  class="btn border-0 ps-1 py-2"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasAddEditProduct"
                  aria-controls="offcanvasAddEditProduct"
                  *ngIf="hasPermission('Product:Update')"
                  (click)="sendProductIdForAddUpdate(item.id)"
                >
                  <img
                    src="/assets/Action_Icons/Edit-Active.svg"
                    alt="edit"
                    matTooltip="Edit Record"
                    matTooltipPosition="above"
                    class="edit"
                  />
                </button>
                <button
                  class="btn border-0 pe-3"
                  *ngIf="
                    item.internalStatus == productInternalStatus.AIProcessFailed
                  "
                  (click)="retryAiProcessing(item.id)"
                >
                  <img
                    src="/assets/Icons/retry-ai.svg"
                    matTooltip="Retry Ai Processing"
                    matTooltipPosition="above"
                    alt=""
                  />
                </button>
                <button
                  class="btn border-0 pe-3"
                  *ngIf="
                    item.listerProduct.listingStatus ==
                    productListingStatus.Failed
                  "
                  (click)="retryListing(item.id)"
                >
                  <img
                    src="/assets/Icons/retry-listing.svg"
                    matTooltip="Retry listing"
                    matTooltipPosition="above"
                    alt=""
                  />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div
        *ngIf="paginatedProductsList.items.length === 0"
        class="nodata-container"
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
    </div>
    <div class="footer-section pe-5" *ngIf="totalRecords > 0">
      <app-pagination
        class="w-100"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [totalRecords]="totalRecords"
        [itemsPerPage]="itemsPerPage"
        [pageSizes]="pageSizes"
        [pagesToShow]="pagesToShow"
        (pageChange)="onPageChange($event)"
        (itemsPerPageChange)="onItemsPerPageChange($event)"
      >
      </app-pagination>
    </div>
  </div>
</div>

<!-- Htmnl for showing add update product offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasAddEditProduct"
  aria-labelledby="offcanvasAddEditProductLabel"
  data-bs-backdrop="static"
>
  <app-add-update-product
    #productAddEdit
    (triggerParentMethod)="handleTriggerFromChild()"
  ></app-add-update-product>
</div>

<!-- Htmnl for showing product details offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="offcanvasProductDetails"
  aria-labelledby="offcanvasProductDetailsLabel"
  data-bs-backdrop="static"
>
  <app-product-detail #productDetails></app-product-detail>
</div>

<!-- Dialog box for AI Product Creator -->
<div
  class="bot-img"
  *ngIf="hasPermission('Product:Create')"
  data-bs-toggle="offcanvas"
  data-bs-target="#aiProductCanvas"
  (click)="openAiProductCreator()"
>
  <img
    src="../../../../../assets/Icons/Frame.svg"
    alt="AI Product Creator"
    style="height: 70px; width: 70px"
  />
</div>

<div *ngIf="showAiDialog" class="ai-dialog-container">
  <app-ai-bot
    (notify)="getProductsList()"
    (closeDialog)="closeAiDialog()"
  ></app-ai-bot>
</div>
